module.exports = __webpack_public_path__ + "img/rarity_star_afterTraining.3eb8cff5.png";